import "./dataset.f56cc6d6.js";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefddd"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefddd"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRequire("2YFJl");

var $aNTv2 = parcelRequire("aNTv2");

var $8RAYl = parcelRequire("8RAYl");

var $cXHfx = parcelRequire("cXHfx");

var $axctD = parcelRequire("axctD");

var $eR6SU = parcelRequire("eR6SU");

var $jDulA = parcelRequire("jDulA");
// ====================================explanstion==============================================
let $1821d360aa03d5f5$var$explanations = {
    "page3_sec1_title": "\u7D71\u8A08\u8CC7\u6599\u96C6\u5404\u5F8C\u8A2D\u8CC7\u6599\u6B04\u4F4D\u586B\u5BEB\u7387\u3002\u5206\u6BCD\u70BA\u8CC7\u6599\u96C6\u7E3D\u6578\uFF0C\u5206\u5B50\u70BA\u6709\u586B\u5BEB\u8A72\u6B04\u4F4D\u7684\u8CC7\u6599\u96C6\u6578\u91CF\u3002\u6BD4\u4F8B\u7D93\u56DB\u6368\u4E94\u5165\u5230\u767E\u5206\u6BD4\u500B\u4F4D\u6578\u3002",
    "page3_sec2_title": "\u7D71\u8A08\u8CC7\u6E90\u5404\u5F8C\u8A2D\u8CC7\u6599\u6B04\u4F4D\u586B\u5BEB\u7387\u3002\u5206\u6BCD\u70BA\u8CC7\u6E90\u7E3D\u6578\uFF0C\u5206\u5B50\u70BA\u6709\u586B\u5BEB\u8A72\u6B04\u4F4D\u7684\u8CC7\u6E90\u6578\u91CF\u3002\u6BD4\u4F8B\u7D93\u56DB\u6368\u4E94\u5165\u5230\u767E\u5206\u6BD4\u500B\u4F4D\u6578\u3002"
};
let $1821d360aa03d5f5$var$stats_data;
// ====================================file_path================================================
(async ()=>{
    try {
        await window.i18nReady;
        $('#languageSwitcher').on('change', function() {
            const selectedLang = $(this).val();
            (0, $8RAYl.default).changeLanguage(selectedLang, function(err, t) {
                // remove old popover
                document.querySelectorAll(".info_btn").forEach((el)=>el.remove());
                (0, $axctD.default).info.gen_popover("h5.section_title", $1821d360aa03d5f5$var$explanations);
                document.querySelectorAll(".card-title-dark").forEach((heading)=>{
                    let text = heading.textContent.trim();
                    let words = text.split(/\s+/);
                    if (selectedLang == "en" && words.length < 2) heading.innerHTML = `${text}</br></br>`;
                });
            });
        });
        // Popover
        (0, $axctD.default).info.gen_popover("h5.section_title", $1821d360aa03d5f5$var$explanations);
        // Obtain update_time
        const update_time = await (0, $jDulA.default).update_time.get_update_time();
        $cXHfx.update_update_time_display(update_time);
        // Load the Daily Stats Data
        const update_month = update_time.slice(0, 7);
        $1821d360aa03d5f5$var$stats_data = await $cXHfx.load_daily_stats_data(update_month);
        // ====================================page_elems===============================================
        let dataset_completeness = (0, $jDulA.default).number_of_data.gen_ratio_arr($1821d360aa03d5f5$var$stats_data[0], $aNTv2.dataset_metadata_mapping, 'datasets');
        let resources_completeness = (0, $jDulA.default).number_of_data.gen_ratio_arr($1821d360aa03d5f5$var$stats_data[0], $aNTv2.res_metadata_mapping, 'resources');
        (0, $eR6SU.default).bar_chart.v_bar_chart_with_label('dataset_metadata', dataset_completeness);
        (0, $axctD.default).cards.gen_cards_by_map("res_metadata", $aNTv2.res_metadata_mapping);
        for(let field in $aNTv2.res_metadata_mapping){
            const cur_display_name = $aNTv2.res_metadata_mapping[field];
            const id = `${field}_chart`;
            let cur_res_comp = {};
            for (let res of resources_completeness)if (res['display_name'] == cur_display_name) cur_res_comp = res;
            (0, $eR6SU.default).pie_chart.simple_pie_chart(id, cur_res_comp);
        }
        (0, $axctD.default).spinner.hideSpinner("loadingOverlay");
    } catch (error) {}
})();


//# sourceMappingURL=metadata.025b6ece.js.map
